/* eslint-disable */
// @ts-nocheck
import { ColumnDef } from '@tanstack/react-table'

import { Vehicle } from '@/interfaces/vehicle'
import { vehicleTypeOptions } from '../filters/constants/statusOptions'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline'
import { Dispatch, SetStateAction } from 'react'

export const getColumns = (
  setShowEditVehicle: Dispatch<SetStateAction<boolean>>,
  setVehicleToEdit: Dispatch<SetStateAction<Vehicle | undefined>>,
  setShowDeleteVehicle: Dispatch<SetStateAction<boolean>>,
  setVehicleToDelete: Dispatch<SetStateAction<number | undefined>>
) => {
  const columns: ColumnDef<Vehicle>[] = [
    {
      accessorKey: 'name',
      header: 'Nombre',
      cell: ({ row }) => {
        const name = row.original?.name || ''
        return <span>{`${name}`.trim()}</span>
      },
      enableHiding: false, // Important column, don't allow hiding
    },
    {
      accessorKey: 'identification',
      header: 'Identificación',
      cell: ({ row }) => {
        const name = row.original?.identification || ''
        return <span>{`${name}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    {
      accessorKey: 'oficialNumber',
      header: 'Número oficial',
      cell: ({ row }) => {
        const name = row.original?.oficialNumber || ''
        return <span>{`${name}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    {
      accessorKey: 'type',
      header: 'Tipo',
      cell: ({ row }) => {
        const type =
          vehicleTypeOptions?.find(
            (status) => status?.value === row.original?.type
          )?.label || ''
        return <span>{`${type}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    /*{
      accessorKey: 'maxWeight',
      header: 'Peso máximo',
      cell: ({ row }) => {
        const name = row.original?.maxWeight || ''
        return <span>{`${name}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    {
      accessorKey: 'maxHeight',
      header: 'Altura máxima',
      cell: ({ row }) => {
        const name = row.original?.maxHeight || ''
        return <span>{`${name}`.trim()}</span>
      },
      enableHiding: true, // Important column, don't allow hiding
    },*/
    {
      accessorKey: 'operatedBy',
      header: 'Operado por',
      cell: ({ row }) => {
        const name = row.original?.operatedBy?.displayName || ''
        const email = row.original?.operatedBy?.email || ''
        return (
          <div className="flex flex-col">
            <span>{`${name}`.trim()}</span>
            <span className="text-gray-500">{`${email}`.trim()}</span>
          </div>
        )
      },
      enableHiding: true, // Important column, don't allow hiding
    },
    {
      accessorKey: 'actions',
      header: 'Acciones',
      cell: ({ row }) => {
        const {
          id,
          name,
          type,
          identification,
          oficialNumber,
          maxHeight,
          maxWeight,
          operatedBy,
          commission,
        } = row.original
        return (
          <div className={'flex justify-start'}>
            <div
              className={`p-2`}
              onClick={() => {
                // DEBUG: Edit button container click handler
              }}
              role={'button'}
            >
              <PencilSquareIcon
                className={`h-5 w-5 text-blue-700`}
                onClick={() => {
                  setShowEditVehicle(true)
                  setVehicleToEdit({
                    id,
                    name,
                    identification,
                    type,
                    oficialNumber,
                    maxHeight,
                    maxWeight,
                    operatedBy,
                    commission,
                  })
                }}
              />
            </div>

            <div
              className={`p-2`}
              onClick={() => {
                // DEBUG: Delete button container click handler
              }}
              role={'button'}
            >
              <TrashIcon
                className={`h-5 w-5 text-red-700`}
                onClick={() => {
                  setShowDeleteVehicle(true)
                  setVehicleToDelete(id)
                }}
              />
            </div>
          </div>
        )
      },
    },
  ]

  return columns
}
